/* eslint-disable jsdoc/require-jsdoc */
import React from 'react';
import DynamicInputPicker from '../../../components/TableFilter/DynamicInputPicker';

function HistoricalEventsFilter({
  legends, fields, onSearch, onClear, filterValue, onChange,
}) {
  return (
    <>
      <div className="filter">
        {fields.map(
          (config) => (
            <DynamicInputPicker
              key={config.id}
              inputType={config.type}
              onChange={onChange.bind(null, config.fieldName)}
              value={filterValue[config.fieldName]}
              {...config}
            />
            // eslint-disable-next-line comma-dangle
          )
        )}
      </div>

      <hr className="spacer-line grey m-t-15" />

      <div className="d-flex justify-content-between align-items-center m-t-15">
        <div className="action-btn">
          <button type="button" className="btn btn-primary" onClick={onSearch}>Search</button>
          {' '}
          <button type="button" className="btn btn-secondary m-l-20" onClick={onClear}>Clear Filters</button>
        </div>

        {legends?.length && (
          <div className="table-key">
            <div className="table-key__label">State Information</div>
            <div className="table-key__wrap">
              {legends.map((legend) => (
                <div key={legend.cssClass} className="table-key__item">
                  <span className={`icon ${legend.cssClass}`} />
                  {' '}
                  <span className="m-l-10">{legend.label}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

    </>
  );
}

export default HistoricalEventsFilter;
